import { render, staticRenderFns } from "./PageTable.vue?vue&type=template&id=ed3b8c68&scoped=true"
import script from "./PageTable.vue?vue&type=script&lang=js"
export * from "./PageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3b8c68",
  null
  
)

export default component.exports